// Internal modules
import { appStore } from '@/store';
import { $logger, features, getContent } from '@/lib';
import { calculateShippingAndTaxes } from './graphql/operations/calculateShippingAndTaxes';
import { updateCallbackOptions } from './graphql/operations/updateCallbackOptions';
import { logFetchingShippingMethodsToFPTI } from './fpti';

const conditionallyCalculateShippingAndTaxes = () => {
  const { ui: uiActions } = appStore.getActions();
  const { setIsShippingShown, toggleIsPageLoading } = uiActions;

  if (!features.isActive('isSntSupported')) {
    $logger.info('snt_not_supported');
    return Promise.resolve();
  }

  logFetchingShippingMethodsToFPTI();

  toggleIsPageLoading(true);
  return calculateShippingAndTaxes()
    .then(updateCallbackOptions)
    .then(() => {
      setIsShippingShown(true);
      toggleIsPageLoading(false);
    })
    .catch(error => {
      // Log and noop if error is thrown
      $logger.warn('calculate_shipping_and_taxes_error', { error });
    });
};

const formatShippingMethodProp = ({ amount, id, label, selected, type }) => ({
  amount,
  label: getContent('shipping.customLabelAndAmount', {
    amount: amount.currencyFormatSymbolISOCurrency,
    label,
  }),
  selected,
  type,
  value: id,
});

const updateSelectedShippingMethod = id => {
  const { shippingMethods } = appStore.getState().api;
  const { setCartData } = appStore.getActions().api;
  const updatedShippingMethods = shippingMethods.map(method => {
    method.selected = method.id === id;
    return method;
  });
  setCartData({
    shippingMethods: updatedShippingMethods,
  });
};

export {
  conditionallyCalculateShippingAndTaxes,
  formatShippingMethodProp,
  updateSelectedShippingMethod,
};
